import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  MenuItem,
  Card,
  CardContent,
  Grid,
} from '@mui/material';
import { DateRange } from 'react-date-range';
import { addDays, differenceInDays, format } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useParams } from 'react-router-dom';
import useFetch from '../../clients/features/get_withcredentials';
import axios from 'axios';
import getCsrfToken from '../../clients/features/get_csrfToken';
import { Spinner } from 'react-bootstrap';



export default function HotelierReservationForm() {
  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;
  const [loading, setLoading] = useState(false)
  const { data, error } = useFetch(`https://api.komorotel.com/api/hotels/rooms/${hotelId}`);
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    roomId: '',
  });

  const [selectedRoom, setSelectedRoom] = useState(null);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 1),
      key: 'selection',
    },
  ]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    const room = data.find((r) => r._id === e.target.value);
    setSelectedRoom(room);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const checkInDate = format(new Date(dateRange[0].startDate), "yyyy-MM-dd");
    const checkOutDate = format(new Date(dateRange[0].endDate), "yyyy-MM-dd");
    const csrfToken = await getCsrfToken(); // Récupérer le token CSRF
    const days =
      differenceInDays(dateRange[0].endDate, dateRange[0].startDate) || 1;

    const totalPrice = selectedRoom ? selectedRoom.price * days : 0;

  
    try {
        setLoading(true);
        await axios({
                method: 'post',
                url: `https://api.komorotel.com/api/reservation/admin`,
                withCredentials:true,
                headers: {
                    'Content-Type': 'application/json',
                    'CSRF-Token': csrfToken // Ajouter le token CSRF
                },
                data:{
                    guest: {
                        firstName: `Admin - ${formData.firstname}`,
                        lastName: formData.lastname,
                        id: hotelId
                    },
                    checkInDate,
                    checkOutDate,
                    roomId: selectedRoom?._id,
                    totalPrice,
                    hotelId
                }
            });
        alert("Réservation enregistrée avec succès !");
} catch (error) {
  console.error("Erreur lors de la réservation :", error);
  alert("Erreur lors de l'envoi de la réservation.");
}finally{
    setLoading(false);
}

    

    
    // Envoie vers ton backend ici
  };

  return (
    loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) :
    <Card sx={{ maxWidth: 700, margin: 'auto', mt: 4, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Réservation directe
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Prénom"
                name="firstname"
                value={formData.firstname}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Nom"
                name="lastname"
                value={formData.lastname}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                label="Choisir une chambre"
                name="roomId"
                value={formData.roomId}
                onChange={handleChange}
              >
                {data.map((room) => (
                  <MenuItem key={room._id} value={room._id}>
                    {room.title} — {room.price}€ / nuit
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  border: '1px solid #ddd',
                  borderRadius: 2,
                  overflow: 'hidden',
                  width: '100%',
                }}
              >
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => setDateRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={dateRange}
                  months={1}
                  direction="horizontal"
                  rangeColors={['#1976d2']}
                />
              </Box>
            </Grid>
            {selectedRoom && (
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Total :{' '}
                  <strong>
                    {differenceInDays(
                      dateRange[0].endDate,
                      dateRange[0].startDate
                    ) || 1}{' '}
                    nuit(s) × {selectedRoom.price}€ ={' '}
                    {(
                      (differenceInDays(
                        dateRange[0].endDate,
                        dateRange[0].startDate
                      ) || 1) * selectedRoom.price
                    ).toFixed(2)}
                    €
                  </strong>
                </Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth>
                Confirmer la réservation
              </Button>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
}
